import { css, SerializedStyles } from '@emotion/react';

export const useStyles = (theme): SerializedStyles => css`
  &:not(:last-child) {
    border-bottom: 1px solid ${theme.palette.divider};
  }

  .item {
    display: flex;
    padding-top: 0;
    padding-bottom: 0;
  }

  .button {
    color: ${theme.palette.text.secondary};
    padding: 10px 8px;
    justify-content: flex-start;
    text-transform: none;
    letter-spacing: 0;
    width: 100%;
    font-weight: ${theme.typography.fontWeightMedium};
  }

  .icon {
    color: ${theme.palette.icon};
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    margin-right: ${theme.spacing(1)};
  }

  .active {
    color: ${theme.palette.primary.main};
    font-weight: ${theme.typography.fontWeightMedium};

    .icon {
      color: ${theme.palette.primary.main};
    }

    .title {
      font-weight: ${theme.typography.fontWeightMedium};
    }
  }

  .icons .icon-active {
    display: none;
  }

  a.active .icons .icon-active {
    display: block;
  }

  a.active .icons .icon-inactive {
    display: none;
  }
`;
